import script from "./algolia-stats-connector.vue?vue&type=script&lang=js"
export * from "./algolia-stats-connector.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__